export default "__VITE_ASSET__BwEOiyIx__"